// Tables as text for spreadsheets: CSV (the bookkeeper pack, "Download CSV" on any table) and TSV (Copy, for pasting
// into Google Sheets or Excel). Both keep text a spreadsheet would run as a formula from running (moved here from
// shared/bills.ts, which re-exports it).

/** Starts like a formula (= + - @, a tab or CR) and isn't a plain number. */
const formulaLike = (v: unknown, s: string) => typeof v !== "number" && /^[=+\-@\t\r]/.test(s) && !/^[-+]?\d+(\.\d+)?$/.test(s);

/**
 * One CSV cell. Text a spreadsheet would run as a formula (starting with = + - @, a tab or CR: an invoice number like
 * =HYPERLINK(…), a description like +cmd) gets a leading ' so it stays text; numbers ("-300.00") stay numbers.
 */
export const csvCell = (v: unknown) => {
  let s = v == null ? "" : String(v);
  if (formulaLike(v, s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replaceAll('"', '""')}"` : s;
};
/** CSV with CRLF line ends (what spreadsheets and Wave's importer expect). */
export const toCsv = (rows: unknown[][]) => `${rows.map((r) => r.map(csvCell).join(",")).join("\r\n")}\r\n`;

/** One cell of tab-separated text, as pasted into a sheet: the same formula guard; tabs and line breaks become spaces. */
export const tsvCell = (v: unknown) => {
  const s = (v == null ? "" : String(v)).replace(/[\t\r\n]+/g, " ");
  return formulaLike(v, s) ? `'${s}` : s;
};
export const toTsv = (rows: unknown[][]) => rows.map((r) => r.map(tsvCell).join("\t")).join("\n");
